/* A680 — the cart shipping estimator's state follows the postcode.

   Empire renders a state select beside the postcode box and seeds it from the
   country list, so with no customer address the first option wins: Australian
   Capital Territory. The shopper types a postcode, leaves the state, and
   Shopify answers 422 to the mismatch. Empire prints its generic failure
   sentence, and the panel reads as broken for everyone outside the ACT.

   An Australian postcode names its state, so this asks nobody anything. */
(function () {
  // [lo, hi, state] — sorted, non-overlapping, generated from the same table
  // the warehouse stock sync routes on.
  var BANDS = [[200, 299, "Australian Capital Territory"], [800, 999, "Northern Territory"], [1000, 2599, "New South Wales"], [2600, 2618, "Australian Capital Territory"], [2619, 2619, "New South Wales"], [2620, 2899, "New South Wales"], [2900, 2920, "Australian Capital Territory"], [2921, 2999, "New South Wales"], [3000, 3999, "Victoria"], [4000, 4999, "Queensland"], [5000, 5999, "South Australia"], [6000, 6999, "Western Australia"], [7000, 7999, "Tasmania"], [8000, 8999, "Victoria"], [9000, 9999, "Queensland"]];

  function stateFor(zip) {
    var digits = String(zip == null ? '' : zip).replace(/\D/g, '');
    // 3 digits covers 0800 typed as 800. Anything shorter is still being typed.
    if (digits.length !== 3 && digits.length !== 4) return null;
    var pc = parseInt(digits, 10);
    for (var i = 0; i < BANDS.length; i++) {
      if (pc >= BANDS[i][0] && pc <= BANDS[i][1]) return BANDS[i][2];
    }
    return null;
  }

  function sync() {
    var zip = document.getElementById('address_zip');
    var prov = document.getElementById('address_province');
    if (!zip || !prov) return;
    var country = document.getElementById('address_country');
    // Only an Australian postcode names a state. Leave every other country to
    // the shopper — guessing there would be worse than the ACT default.
    if (country && country.value && country.value !== 'Australia') return;
    var want = stateFor(zip.value);
    // ☠️ No match means LEAVE IT. A half-typed postcode must not blank the
    // select, or the request goes out with no province and 422s just the same.
    if (!want || prov.value === want) return;
    for (var i = 0; i < prov.options.length; i++) {
      if (prov.options[i].value === want) {
        prov.value = want;
        prov.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }
  }

  // Every keystroke, so the shopper SEES the state settle on their own state
  // and can still override it. The select stays visible; nothing is hidden.
  document.addEventListener('input', function (e) {
    if (e.target && e.target.id === 'address_zip') sync();
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.id === 'address_zip') sync();
  }, true);

  // ☠️ CAPTURE PHASE, both of these. Empire binds a DELEGATED jQuery click on
  // [data-cartshipping-submit] and reads #address_province inside that handler.
  // A bubble-phase listener would set the state one request too late — the
  // shopper would have to press Calculate twice, which is the same bug wearing
  // a hat. Capture runs before any delegated handler on an ancestor.
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('[data-cartshipping-submit]')) sync();
    // Opening the panel syncs a postcode that was already there — a signed-in
    // customer's default address arrives prefilled and fires no input event.
    if (e.target.closest('[data-cartshipping-toggle]')) setTimeout(sync, 0);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(sync, 0); });
  } else {
    setTimeout(sync, 0);
  }
})();
